import { ModalProvider, PopupProvider } from "vig-ui-library";
import BaseLayout from "../Layout/BaseLayout";
import { Outlet } from "react-router-dom";

export const BaseLayoutRoute = () => {
    return (
        <ModalProvider>
            <PopupProvider>
                <BaseLayout>
                    <Outlet />
                </BaseLayout>
            </PopupProvider>
        </ModalProvider>
    );
};